import dayjs from 'dayjs';
import { PARAMS_EXPIRY_DAYS, URL_TRACKING_PARAMS } from '../constants';

export const setUtmTrackingParamsToCookie = (): void => {
  const params = new URLSearchParams(window.location.search);

  URL_TRACKING_PARAMS.forEach((key) => {
    const value = params.get(key);

    if (value) {
      const expireDate = dayjs().add(PARAMS_EXPIRY_DAYS, 'day').toDate();
      const cookieValue = key === 'landing_url' ? encodeURIComponent(value) : value;

      document.cookie = `${key}=${cookieValue}; expires=${expireDate.toUTCString()}; path=/; SameSite=Lax;`;
    }
  });
};
